import ButtonField from "../../../components/buttonField/buttonField";
import { ButtonFieldProps } from "../../../components/buttonField/types/buttonFieldProps";
import { classNameBtn, iconPosition } from "../../../components/shared/button/types/buttonProps";
import { HomeViewProps, HomeViewTypes } from "./types/homeViewProps";
import { ReactComponent as addNotes } from '../../../icons/add_notes.svg';
import { ReactComponent as findInPage } from '../../../icons/find_in_page.svg';
import { ReactComponent as polyline } from '../../../icons/polyline.svg';
import { ReactComponent as autorenew } from '../../../icons/autorenew.svg';
import { stylizationVerticalAlign } from "../../../components/shared/stylization";
import React, { useContext, useEffect, useState } from "react";
import './homeView.scss';
import AddRegistrationCardModal from "./addRegistrationCardModal/addRegistrationCardModal";
import UpdateCardModal from "./updateCardModal/updateCardModal";
import UploadGeometryModal from "./uploadGeometryModal/uploadGeometryModal";
import { UpdateCardModalType } from "./updateCardModal/types/updateCardModalProps";
import PermissionsContext from "../../../contexts/permissionsContext";
import { ObjectCategories } from "../administrationView/AdministrationPermissionExtendedView/types/administrationsPermissionExtendedViewProps";
//import HomeTable from "./homeTable/homeTable";

const HomeView = (props: HomeViewProps) => {
    const [activeBtn, setActiveBtn] = useState<HomeViewTypes | null>(null);
    const { functionsPermissions, extendedUserPermissions } = useContext(PermissionsContext);

    useEffect(() => {
        if (props.data && props.data.isTriggeredByAdminDecision) setActiveBtn(HomeViewTypes.UploadGeometry);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getBtnProps = (actionType: HomeViewTypes, title: string, icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>,
        onClick: React.MouseEventHandler<HTMLButtonElement>, disabled: boolean): ButtonFieldProps => {
        let className = classNameBtn.Big + " body-txt-large";
        if (actionType === activeBtn) {
            className += " bigBtnActive";
        }
        return {
            BtnProps: {
                onClick: disabled ? () => { return } : onClick,
                style: {
                    width: '100%',
                    height: '104px'
                },
                className: className,
                disabled: disabled
            },
            placeHolder: title,
            placeHolderStyle: stylizationVerticalAlign,
            additionalIcon: icon,
            iconPosition: iconPosition.Start
        };
    }

    const addKR = () => {
        setActiveBtn(HomeViewTypes.AddKR);
    }

    const addOOP = () => {
        setActiveBtn(HomeViewTypes.AddOP);
    }

    const updateKR = () => {
        setActiveBtn(HomeViewTypes.UpdateKR);
    }

    const uploadGeometry = () => {
        setActiveBtn(HomeViewTypes.UploadGeometry);
    }

    const onClose = () => {
        setActiveBtn(null);
    }

    const getProcessOAndKPermissions = (functionPermission: boolean) => {
        if (extendedUserPermissions.userObjectCategories?.length! > 0) return functionPermission && 
            (extendedUserPermissions.userObjectCategories?.includes(ObjectCategories.Landslide) ||
            extendedUserPermissions.userObjectCategories?.includes(ObjectCategories.EndangeredArea))
        else return functionPermission;
    }

    const getAddProtocolPermissions = () => {
        if (extendedUserPermissions.userObjectCategories?.length! > 0) return functionsPermissions.addPO.active && 
            extendedUserPermissions.userObjectCategories?.includes(ObjectCategories.Protocol) &&
            (extendedUserPermissions.userObjectCategories?.includes(ObjectCategories.Landslide) ||
            extendedUserPermissions.userObjectCategories?.includes(ObjectCategories.EndangeredArea));
        else return functionsPermissions.addPO.active;
    }

    return (<div className="homeViewContent">
        <div className="homeViewBtns">
            <ButtonField {...getBtnProps(HomeViewTypes.AddKR, "Dodaj kartę rejestracyjną", addNotes, addKR, !getProcessOAndKPermissions(functionsPermissions.processO.active))}></ButtonField>
            <ButtonField {...getBtnProps(HomeViewTypes.AddOP, "Dodaj protokół obserwacji", findInPage, addOOP, !getAddProtocolPermissions())}></ButtonField>
            <ButtonField {...getBtnProps(HomeViewTypes.UpdateKR, "Aktualizuj kartę rejestracyjną", autorenew, updateKR, !getProcessOAndKPermissions(functionsPermissions.processK.active))}></ButtonField>
            <ButtonField {...getBtnProps(HomeViewTypes.UploadGeometry, "Wgraj geometrię", polyline, uploadGeometry, !functionsPermissions.addGeometry.active)}></ButtonField>
        </div>
        <div>
            {/*<HomeTable />*/}
        </div>
        {activeBtn === HomeViewTypes.AddKR && <AddRegistrationCardModal onClose={onClose} />}
        {activeBtn === HomeViewTypes.UpdateKR && <UpdateCardModal
            title={"Aktualizuj kartę rejestracyjną"}
            titleIcon={autorenew}
            actionText={"Aktualizuj"}
            onClose={onClose}
            modalType={UpdateCardModalType.UpdateKR}
        />}
        {activeBtn === HomeViewTypes.AddOP && <UpdateCardModal
            title={"Dodaj protokół obserwacji"}
            titleIcon={findInPage}
            actionText={"Dodaj"}
            onClose={onClose}
            modalType={UpdateCardModalType.AddPO}
        />}
        {activeBtn === HomeViewTypes.UploadGeometry && <UploadGeometryModal
            title={"Wgraj geometrię"}
            titleIcon={polyline}
            onClose={onClose}
            isTriggeredByAdminDecision={props.data && props.data.isTriggeredByAdminDecision === true}
        />}
    </div>);
};

export default HomeView;